import {useCallback, useState} from 'react';

type useImageLoadedDef = () => {
  imgProps: {
    onLoadStart: () => void;
    onLoad: () => void;
    onError: () => void;
  };
  status: string;
  isLoading: boolean;
  loadingFailed: boolean;
  loadingSuccessful: boolean;
}

const useImageLoaded: useImageLoadedDef = () => {
  const [status, setStatus] = useState('loading');

  const onLoadStart = useCallback((): void => {
    setStatus('loading');
  }, [setStatus]);

  const onLoad = useCallback((): void => {
    setStatus('success');
  }, [setStatus]);

  const onError = useCallback((): void => {
    setStatus('error');
  }, [setStatus]);

  return {
    imgProps: {
      onLoadStart,
      onLoad,
      onError
    },
    status,
    isLoading: status === 'loading',
    loadingFailed: status === 'error',
    loadingSuccessful: status === 'success',
  }
}

export default useImageLoaded;
